import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const AboutMeComponent = () => {
  const [fontSize, setFontSize] = useState('1rem');
  const [titleSize, setTitleSize] = useState('1.2rem');

  useEffect(() => {
    const updateFontSize = () => {
      const w = window.innerWidth;
      if (w < 400) {
        setFontSize('0.38rem');
        setTitleSize('0.65rem');
      } else if (w < 500) {
        setFontSize('0.45rem');
        setTitleSize('0.75rem');
      } else if (w < 600) {
        setFontSize('0.60rem');
        setTitleSize('0.9rem');
      } else if (w < 700) {
        setFontSize('0.68rem');
        setTitleSize('1rem');
      } else {
        setFontSize('0.85rem');
        setTitleSize('1.2rem');
      }
    };

    updateFontSize();
    window.addEventListener('resize', updateFontSize);
    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  const sharedBoxStyle = {
    backgroundColor: 'rgba(32, 32, 32, 0.55)',
    borderRadius: '30px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
    color: 'white',
    fontFamily: 'Noto Sans, sans-serif',
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', px: 2, py: 3 }}>
      <Box
        sx={{
          ...sharedBoxStyle,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          padding: 2,
          gap: 2,
          maxWidth: '1100px',
          width: '100%',
        }}
      >
        {/* Left: Image with enforced 2:3 aspect ratio */}
        <Box
          sx={{
            width: { xs: '35%', sm: '10rem', md: '12rem' },
            position: 'relative',
            flexShrink: 0,
            borderRadius: '6px',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              display: 'block',
              paddingTop: '150%', // 2:3 aspect ratio
            },
          }}
        >
          <Box
            component="img"
            src="/images/aboutMe.jpg"
            alt="Dr. Elena DiRusso, DO"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Right: Text */}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', pr: 1 }}>
          <Typography
            component="h2"
            variant="h5"
            sx={{
              fontWeight: 'bold',
              fontSize: titleSize,
              mb: 1,
              whiteSpace: 'nowrap',
            }}
          >
            About Me
          </Typography>

          <Typography
            sx={{
              fontSize: fontSize,
              lineHeight: 1.5,
              textAlign: 'left',
            }}
          >
            I’m Dr. Elena DiRusso, an osteopathic physician with a passion for holistic, hands-on care. I graduated from Tulane University with a degree in biomedical engineering and earned my medical degree from the New York Institute of Technology College of Osteopathic Medicine (NYIT-COM). I completed my residency at St. Barnabas Hospital in the Bronx, where I served as Chief Resident during my final year and deepened my training in osteopathic principles and patient-centered care. During my residency, I gained extensive experience treating newborns, post-operative patients, and trauma patients.
            <br /><br />
            I specialize in Osteopathic Manipulative Medicine (OMM), a hands-on approach to diagnosing and treating a wide range of conditions. My focus is on helping patients restore balance, reduce pain, and improve function—without relying solely on medication.
            <br /><br />
            Whether you’re dealing with chronic pain, recovering from an injury, or simply looking for a more integrated approach to your health, I’m here to help.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutMeComponent;
